<template>
    <Navbar></Navbar>
    <div class="page-box">
        <div class="img-box page-banner">
            <img src="/assets/manufacture/transmission/taizhou/tz.jpg" alt=""></img>
            <div class="title-box">
                <div class="manufacture-t1">
                    传动泰州工厂
                </div>
                <div class="manufacture-t2">
                    位于江苏省泰州市，2020年12月建设完成，占地1.2万平方米<br />
                    具备液压模块、双离合模块组装（各50万）及双离合模块壳体（25万）自制能力
                </div>
            </div>
        </div>

        <div class="page-title-box">
            <div class="page-t1">
                DCM/HCM组装线
            </div>
        </div>

        <div class="page-sw">
            <div class="swiper-container kv-container swiper-item">
                <div class="swiper-wrapper">
                    
                    <div class="swiper-slide">
                        <div class="text-box ">
                            <div class="title">
                                EOL测试
                            </div>
                            <div class="destils">
                                ① 采用专用测试台架开展100%全功能、全性能测试，实现产品质量全生命周期可追溯<br />
                                ② 台架自动化率达100%，设备可动率稳定在95%以上，保障测试高效连续运行<br />
                                ③ 程序内置自动互锁防错机制，从根源规避人员、产品及设备的损坏风险。
                            </div>
                        </div>
                        <div class="img-box">
                            <img src="/assets/manufacture/transmission/taizhou/tz1-1.jpg" alt="">
                        </div>
                    </div>

                </div>
                <div class="kv_pagination swiper-pagination left"></div>
            </div>
        </div>


    </div>
    <Footer></Footer>
</template>

<script setup>
import { ref, onMounted, onUnmounted, nextTick } from 'vue';
import Navbar from '@/components/Navbar.vue';
import Footer from '@/components/Footer.vue';
import Swiper from 'swiper/bundle';
import 'swiper/swiper-bundle.css';
import $ from 'jquery';

// 存储所有swiper实例，方便销毁
const swiperInstances = ref([]);

// 初始化所有轮播的核心函数
const initAllSwipers = async () => {
    await nextTick();

    const swiperElements = document.querySelectorAll('.swiper-item');

    swiperElements.forEach(el => {
        if (el) {
            const swiper = new Swiper(el, {
                speed: 1300,
                pagination: {
                    el: el.querySelector(".swiper-pagination"), // 绑定当前容器内的分页器
                    clickable: true,
                },
                direction: "horizontal",
                slidesPerView: 1,
                // spaceBetween: 20,
                simulateTouch: true,
                effect: 'fade',
                breakpoints: {
                    768: {},
                    1024: {}
                },
                // navigation: {
                //     nextEl: el.querySelector(".btn-r"),
                //     prevEl: el.querySelector(".btn-l"),
                //     disabledClass: 'swiper-button-disabled',
                // },
                on: {
                    // init: function () {
                    //     console.log('轮播初始化完成');
                    // },
                    // slideChangeTransitionStart(swiper) {
                    //     let swiperIndex = swiper.realIndex;
                    //     console.log('当前轮播索引：', swiperIndex);
                    // },
                },
            });
            swiperInstances.value.push(swiper); // 保存实例
        }
    });
};

// 页面挂载时初始化轮播
onMounted(() => {
    initAllSwipers();
});

// 页面卸载时销毁轮播实例（防止内存泄漏）
onUnmounted(() => {
    swiperInstances.value.forEach(swiper => {
        swiper.destroy(true, true);
    });
    swiperInstances.value = [];
});
</script>

<script>
export const pageConfig = {
    title: '传动泰州工厂 - 蜂巢汽车官网',
    keywords: '蜂巢,蜂巢汽车,发动机,变速器,电子',
    description: '蜂巢汽车科技集团有限公司，是一家掌握从传统动力到混合动力再到纯电动力（含控制器）全领域动力总成、汽车智能化集成系统等核心技术的零部件企业，具备完整的软、硬件产业链；能为客户提供高效节能环保的汽车动力总成、智能化出行解决方案',
    outputPath: 'manufacture/tr/taizhou.html'
};

import { createApp } from 'vue';
import App from './taizhou.vue';
import store from '@/store/index';
import "@/assets/styles/global.scss";
import "@/assets/styles/manufacture-detail.scss";

function mountApp() {
    const appNode = document.getElementById('app');
    if (appNode) {
        if (appNode._vueApp) {
            appNode._vueApp.unmount();
            delete appNode._vueApp;
        }
        const app = createApp(App);
        app.use(store);
        appNode._vueApp = app.mount(appNode);
    }
}

document.addEventListener('DOMContentLoaded', mountApp);

if (module.hot) {
    module.hot.accept('./taizhou.vue', () => {
        mountApp();
    });
}
</script>

<style lang="scss"></style>
